import { render } from "./DrugSearch.vue?vue&type=template&id=3fca63fa"
import script from "./DrugSearch.vue?vue&type=script&lang=js"
export * from "./DrugSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__